import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

/* eslint-disable react/default-props-match-prop-types */
import React, { useContext, useEffect } from 'react';
import clsx from 'clsx';
import Icon from '../icon';
import Popup from '../popup';
import Loading from '../loading';
import { lockClick } from './lock-click';
import { isDef } from '../utils';
import ConfigProviderContext from '../config-provider/ConfigProviderContext'; // eslint-disable-next-line react/require-default-props

var Toast = function Toast(props) {
  var clickable = false;

  var _useContext = useContext(ConfigProviderContext),
      prefixCls = _useContext.prefixCls,
      createNamespace = _useContext.createNamespace;

  var _createNamespace = createNamespace('toast', prefixCls),
      _createNamespace2 = _slicedToArray(_createNamespace, 1),
      bem = _createNamespace2[0];

  var toggleClickable = function toggleClickable() {
    var newValue = props.visible && props.forbidClick;

    if (clickable !== newValue) {
      clickable = newValue;
      lockClick(clickable);
    }

    if (!props.visible) {
      lockClick(false);
    }
  };

  var onClick = function onClick() {
    if (props.closeOnClick) {
      props.onClose();
    }
  };

  useEffect(function () {
    toggleClickable();
  }, [props.visible, props.forbidClick]);

  var renderIcon = function renderIcon() {
    var icon = props.icon,
        type = props.type,
        iconPrefix = props.iconPrefix,
        iconSize = props.iconSize,
        loadingType = props.loadingType;
    var hasIcon = icon || type === 'success' || type === 'fail';

    if (hasIcon) {
      return typeof icon === 'string' ? /*#__PURE__*/React.createElement(Icon, {
        name: icon || (type === 'fail' ? 'cross' : type),
        size: iconSize,
        className: clsx(bem('icon')),
        classPrefix: iconPrefix
      }) : icon;
    }

    if (type === 'loading') {
      return /*#__PURE__*/React.createElement(Loading, {
        className: clsx(bem('loading')),
        type: loadingType
      });
    }

    return null;
  };

  var renderMessage = function renderMessage() {
    var message = props.message;

    if (isDef(message) && message !== '') {
      return /*#__PURE__*/React.createElement("div", {
        className: clsx(bem('info'))
      }, message);
    }

    return null;
  };

  return /*#__PURE__*/React.createElement(Popup, {
    className: clsx([bem([props.position, _defineProperty({}, props.type, !props.icon)]), props.className]),
    visible: props.visible,
    overlay: props.overlay,
    transition: props.transition,
    overlayClass: props.overlayClass,
    overlayStyle: props.overlayStyle,
    closeOnClickOverlay: props.closeOnClickOverlay,
    lockScroll: false,
    onClick: onClick,
    onClose: props.onClose,
    onClosed: props.onClosed,
    onOpened: props.onOpened,
    teleport: props.teleport
  }, renderIcon(), renderMessage());
};

Toast.defaultProps = {
  type: 'info',
  duration: 2000,
  position: 'middle',
  transition: 'rv-fade',
  loadingType: 'circular',
  overlay: false
};
export default Toast;